import React, { useContext } from 'react';
import styled from 'styled-components';
import { Flex, FlexColumn } from '@ubeya/shared-web/components';
import { ReactComponent as EmptyStateIcon } from '@ubeya/shared-web/assets/empty-state-shifts.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Container = styled(Flex)`
  justify-content: center;
  gap: 16px;
  margin-top: 20px;

  > svg {
    min-width: 100px;
    min-height: 100px;
  }
`;
const Column = styled(FlexColumn)`
  gap: 8px;
`;

const ContractEmptyState = ({ title = 'noContractAssigned', description = 'noContractAssignedDescription' }) => {
  const { t } = useContext(ConfigContext);
  return (
    <Container>
      <EmptyStateIcon />
      <Column>
        <h3>{t(title)}</h3>
        <p>{t(description)}</p>
      </Column>
    </Container>
  );
};

export default ContractEmptyState;
